import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { deleteWard, getAllWards, createWard, editWard, getDistrictWards } from '../../api/axiosWards';
import { getAllDistricts, getRegionDistricts } from '../../api/axiosDistricts';
import { getAllRegions } from '../../api/axiosRegions';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';






const Wards = () => {
  const { regions, setRegions, districts, setDistricts,wards, setWards, setFetcherror} = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(true);
  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [displayWards, setDisplayWards] = useState([]);
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedEditedDistrict, setSelectedEditedDistrict] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedEditedRegion, setSelectedEditedRegion] = useState("");
  
  const [ward, setWard] = useState("");
  const [editedWard, setEditedWard] = useState("");
  


 

  const NewTitle = "All Wards";
  useEffect(() => {
    
    getAllWards(setDisplayWards, setFetcherror,setIsLoading);
    getAllDistricts(setDistricts, setFetcherror);
    getAllRegions(setRegions, setFetcherror);
    
  }, []);

  // Create New Array of Wards with Districts and Regions.

  // const newwardsArray = wards.map((ward) => {

  //   const newdistrictArray = districts.map((district) => {
  //     const result = regions.find((region) => region.id === district.region_id);
  //     return { ...district, region: result ? result.name : null };
  //   });

  //   const result = newdistrictArray.find((item) => item.id === ward.district_id);
  //   return {...ward, district:result? result.name:null, region_id:result?result.region_id:null, region:result?result.region:null}
  // });

  const filteredWards = displayWards.filter((item) => item?.name.toLowerCase().includes(globalFilter.toLowerCase()) || item.district.toLowerCase().includes(globalFilter.toLowerCase()))
  const filteredReversedWards = filteredWards.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setDisplayWards, setFetcherror, handleAllToasts,setIsLoading) => {
    return () => {
      deleteWard(pkid, setDisplayWards, setFetcherror, handleAllToasts,setIsLoading);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Ward?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items?.find((item) => item.id === pkid);
    setEditedWard(foundItem?.name);
    setSelectedEditedDistrict(districts.find((district)=>district.id === foundItem?.district_id));
    setSelectedEditedRegion(regions.find((region)=>region.id === foundItem?.region_id));
  }

  
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
          
          <SearchToolBar
                    setAddItemDialogVisible={setAddItemDialogVisible}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    searchPlaceholder="Wards"
                    createLabel="Ward"
            />

       
        {!isLoading &&
          <DataTable
            value={filteredWards}
            showGridlines
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 20, 50]}
            emptyMessage="No Wards Found"
          >
            <Column header="S/N" body={(rowData) => displayWards.indexOf(rowData) + 1} sortable> </Column>
            <Column header="Region" body={(rowData) => rowData?.region} sortable></Column>
            <Column header="District" body={(rowData) => rowData?.district} sortable></Column>
            <Column header="Ward" body={(rowData) => rowData.name} sortable></Column>
            <Column header="Actions" body={(rowData) => (
                <TableActions
                  id={rowData.id}
                  data={displayWards}
                  getItemtoEdit={getItemtoEdit}
                  setSelectedId={setSelectedId}
                  setEditDialogVisible={setEditDialogVisible}
                  setDeleteDialogVisible={ setDeleteDialogVisible}
              />           
            )}>
            </Column>
          </DataTable>
        }

        
        {isLoading && 
        
        <DataTable value={skeletonitems} className="p-datatable-striped">
        <Column field="S/N" header="S/N" style={{ width: '25%' }} body={<Skeleton />}></Column>
        <Column field="Region" header="Region" style={{ width: '25%' }} body={<Skeleton />}></Column>
        <Column field="District" header="District" style={{ width: '25%' }} body={<Skeleton />}></Column>
        <Column field="Ward" header="Ward" style={{ width: '25%' }} body={<Skeleton />}></Column>
        <Column field="Actions" header="Actions" style={{ width: '25%' }} body={<Skeleton />}></Column>
        </DataTable>
        }
      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Ward" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createWard(ward,selectedDistrict?.id, setWard, setFetcherror, handleAllToasts, setDisplayWards,setIsLoading);
                if (ward ) { setAddItemDialogVisible(false); }
              }}>
                   <label htmlFor="wardregion" className="block text-900 font-medium mb-2">Region </label>
                  <Dropdown
                  value={selectedRegion} onChange={(e) => { setSelectedRegion(e.value); getRegionDistricts(setDistricts, setFetcherror, e.value?.id);}}
                  options={regions} optionLabel="name"
                   placeholder="-- Select Region --" showClear className="w-full mb-4"
                  />
                
                  <label htmlFor="warddistrict" className="block text-900 font-medium mb-2">District </label>
                  <Dropdown
                  value={selectedDistrict} onChange={(e) => { setSelectedDistrict(e.value); getDistrictWards(setWards, setFetcherror, e.value?.id); }}
                  options={districts} optionLabel="name"
                  placeholder="-- Select District --" showClear className="w-full mb-4"
                  />
                

                  <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Ward </label>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Ward Name"
                    value={ward}
                    onChange={(e) => setWard(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setWard("");  }} className="p-button-text p-2 px-3" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="p-2 px-3"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Ward" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editWard( selectedId, editedWard, setEditedWard, selectedEditedDistrict, setSelectedEditedDistrict, setFetcherror, handleAllToasts, setDisplayWards,setIsLoading);
                if (editedWard) { setEditDialogVisible(false); }
                }}>
                  <label htmlFor="wardregion" className="block text-900 font-medium mb-2">Region </label>
                  <Dropdown
                  value={selectedEditedRegion} onChange={(e) => { setSelectedEditedRegion(e.value); getRegionDistricts(setDistricts, setFetcherror, e.value?.id);}}
                  options={regions} optionLabel="name"
                   placeholder="-- Select Region --" showClear className="w-full mb-4"
                  />
                
                  
                  <label htmlFor="warddistrict" className="block text-900 font-medium mb-2">District </label>
                  <Dropdown
                   value={selectedEditedDistrict} onChange={(e) => setSelectedEditedDistrict(e.value)}
                   options={districts} optionLabel="name"
                  placeholder="-- Select District --" showClear className="w-full mb-4"
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Ward Name"
                    value={editedWard}
                    onChange={(e) => setEditedWard(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setWard("");  }} className="p-button-text p-2 px-3" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="p-2 px-3"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setDisplayWards, setFetcherror, handleAllToasts,setIsLoading)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Wards


